module.exports = __webpack_public_path__ + "img/img_case1.55f72785.png";